import styled from 'styled-components';

import { Button, TextButton } from '@xing-com/button';
import { Label } from '@xing-com/label';
import { MEDIA_LARGE } from '@xing-com/layout-primitives';
import { mediaWideNavless } from '@xing-com/layout-tokens';
import { InputBar } from '@xing-com/text-field';
import {
  spaceS,
  spaceL,
  spaceXXL,
  scale000,
  spaceM,
  spaceXL,
  space3XL,
  scale410,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  margin-bottom: ${spaceXXL};
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceS};
`;

export const CheckboxContainer = styled.div`
  display: inline-grid;
  flex-wrap: wrap;
  gap: ${spaceS};
`;

export const StyledLabel = styled(Label)`
  display: flex;
  gap: ${spaceS};
`;

export const IconContainer = styled.span`
  display: flex;
  margin-inline: ${spaceS} ${scale000};
`;

export const ShowMoreButton = styled(TextButton)`
  justify-content: flex-start;
`;

export const ShowMoreContent = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledInputBar = styled(InputBar)`
  width: 100%;
`;

export const FiltersContainer = styled.div`
  max-width: ${scale410};
`;

export const MobileFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaceS};
  margin-block: ${spaceM} ${spaceM} 0 ${spaceM};
`;

export const MobileFiltersScrollable = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: ${spaceS};
  overflow-x: auto;

  & > * {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const MobileFiltersSheetContainer = styled.div`
  margin-block: ${spaceXL};
  margin-inline: ${spaceL};
`;

export const InputBarSearch = styled(InputBar)`
  flex-grow: 1;
`;

export const SearchSlot = styled.form`
  display: flex;
  gap: ${spaceL};
  margin: ${spaceS} auto ${spaceM} auto;
  max-width: 720px;

  ${MEDIA_LARGE} {
    margin: ${spaceXXL} auto ${spaceM} auto;
  }
`;

export const AppliedFiltersTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceS};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaWideNavless} {
    margin-top: ${spaceXL};
    margin-bottom: ${space3XL};
  }
`;

export const ResetButton = styled(Button)`
  flex-shrink: 0;
`;

export const MobileAppliedFiltersContainer = styled.div`
  margin-bottom: ${spaceXXL};
`;

export const MobileFiltersSheetHeader = styled(Headline)`
  margin-bottom: ${spaceXXL};
`;
